export default {
  name: 'EmptyLayout',
};
